import { ParentProps, Show, createContext } from "solid-js"
import { OnNextHandler, StepContext, requireWizardContext } from "../WizardContext";
import Flexbox from "../../st-flexbox/st-flexbox";


type StepProps = {
    title: string;
    visible?: () => boolean;
    onNext?: OnNextHandler;
};

export const StepContextJsx = createContext<StepContext>();

export function Step(props: ParentProps<StepProps>) {
    const ctx = requireWizardContext();
    const stepCtx = ctx.addStep(props.title, props.visible, props.onNext);

    return <StepContextJsx.Provider value={stepCtx}>
        <Show when={stepCtx.isVisible() && stepCtx.id === ctx.currStep()}>
            <Flexbox dir="vertical" auto middle>
                {props.children}
            </Flexbox>
        </Show>
    </StepContextJsx.Provider>
}
